import { render, staticRenderFns } from "./MonthsEstablishmentSettingsTable.vue?vue&type=template&id=2b9f2609&"
import script from "./MonthsEstablishmentSettingsTable.vue?vue&type=script&lang=js&"
export * from "./MonthsEstablishmentSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports